// Comentários / evidências por etapa (opcionais). Texto + link opcional
// (ex.: laudo, arte, planilha no Drive/SharePoint).
import { supabase } from './supabase';

export interface StageNote {
  id: string;
  n: number;
  authorId: string | null;
  authorName: string | null;
  body: string | null;
  attachmentUrl: string | null;
  attachmentName: string | null;
  mentionedIds: string[];
  createdAt: string;
}

export async function loadNotes(productId: string): Promise<StageNote[]> {
  const { data } = await supabase
    .from('stage_notes')
    .select('id, n, author_id, author_name, body, attachment_url, attachment_name, mentioned_ids, created_at')
    .eq('product_id', productId)
    .order('created_at', { ascending: false });
  return ((data ?? []) as Record<string, unknown>[]).map((r) => ({
    id: r.id as string,
    n: r.n as number,
    authorId: (r.author_id as string) ?? null,
    authorName: (r.author_name as string) ?? null,
    body: (r.body as string) ?? null,
    attachmentUrl: (r.attachment_url as string) ?? null,
    attachmentName: (r.attachment_name as string) ?? null,
    mentionedIds: (r.mentioned_ids as string[]) ?? [],
    createdAt: r.created_at as string,
  }));
}

export async function addNote(params: {
  orgId: string;
  productId: string;
  n: number;
  authorId: string | null;
  authorName: string | null;
  body: string | null;
  attachmentUrl?: string | null;
  attachmentName?: string | null;
  mentionedIds?: string[];
}): Promise<{ error?: string; id?: string }> {
  const { data, error } = await supabase
    .from('stage_notes')
    .insert({
      org_id: params.orgId,
      product_id: params.productId,
      n: params.n,
      author_id: params.authorId,
      author_name: params.authorName,
      body: params.body,
      attachment_url: params.attachmentUrl ?? null,
      attachment_name: params.attachmentName ?? null,
      mentioned_ids: params.mentionedIds?.length ? params.mentionedIds : null,
    })
    .select('id')
    .single();
  return { error: error?.message, id: (data as { id: string } | null)?.id };
}

/** Edita um comentário já postado (autor ou PMO). */
export async function updateNote(
  id: string,
  patch: { body?: string | null; mentionedIds?: string[] },
): Promise<{ error?: string }> {
  const row: Record<string, unknown> = { updated_at: new Date().toISOString() };
  if ('body' in patch) row.body = patch.body ?? null;
  if (patch.mentionedIds) row.mentioned_ids = patch.mentionedIds.length ? patch.mentionedIds : null;
  const { error } = await supabase.from('stage_notes').update(row).eq('id', id).select('id');
  return { error: error?.message };
}

export async function deleteNote(id: string): Promise<{ error?: string }> {
  const { error } = await supabase.from('stage_notes').delete().eq('id', id);
  return { error: error?.message };
}
